// style.ts
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    display: "flex",
    minHeight: "100vh",
    width: "100vw",
    overflow: "hidden",
  },

  /* LEFT */
  leftPane: {
    position: "relative",
    flex: "1 1 50%",
    minWidth: 0,
    display: "flex",
    alignItems: "stretch",
    justifyContent: "center",
    padding: theme.spacing(4, 6),
    backgroundColor: theme.palette.background.default,
  },
  brand: {
    position: "absolute",
    top: theme.spacing(3),
    left: theme.spacing(3),
    width: 150,
    height: "auto",
  },
  formWrap: {
    margin: "auto",
    width: "100%",
    maxWidth: 420,
  },
  form: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(5, 4),
    borderRadius: 16,
    boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
  },
  title: {
    marginBottom: `${theme.spacing(3)} !important`,
    textAlign: "left",
  },
  input: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": { borderColor: theme.palette.primary.main },
      "&:hover fieldset": { borderColor: theme.palette.primary.main },
      "&.Mui-focused fieldset": { borderColor: theme.palette.primary.main },
    },
  },
  buttonLogIn: {
    width: "100%",
    fontWeight: "700 !important",
    borderRadius: "999px !important",
  },
  sectionSignUp: {
    textAlign: "center",
    marginTop: `${theme.spacing(2)} !important`,
    fontWeight: "700 !important",
  },
  sectionForgotPassword: {
    textAlign: "center",
    marginTop: `${theme.spacing(2)} !important`,
  },

  /* RIGHT visual */
  rightPane: {
    flex: "1 1 50%",
    minWidth: 0,
    backgroundImage: 'url("/gameoo-login-bg.png")',
    backgroundSize: "cover",
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
  },

  /* Responsive: stack on small screens */
  "@media (max-width: 900px)": {
    root: { flexDirection: "column" },

    rightPane: { display: "none" },

    leftPane: {
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(3, 2),
      backgroundImage: 'url("/gameoo-login-bg.png")',
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
    formWrap: { margin: 0, width: "100%", maxWidth: 520 },

    form: {
      backgroundColor: "rgba(255,255,255,0.9)",
      backdropFilter: "saturate(120%) blur(4px)",
    },
    brand: { top: 12, left: 12, width: 100 },
  },
}));

export default useStyles;
